import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { CostsPerEmployee } from "../models/cost-per-employee";
import { FilterCostsPerEmployeeCatalog } from "../models/filters/filter-costs-per-employee-catalog";

@Injectable({
  providedIn: 'root'
})
export class CostsPerEmployeeCatalogService { 

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/costsPerEmployeesCatalog'; 

  findAllPageableCostsPerEmployeeCatalog(filterCostsPerEmployeeCatalog: FilterCostsPerEmployeeCatalog, page: number, pageSize: number): Observable<any> {
    return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterCostsPerEmployeeCatalog);
  }

  findCostsPerEmployeeCatalogById(id: number): Observable<CostsPerEmployee> {
    return this.http.get<CostsPerEmployee>(`${this.url}/${id}`);
  }

  createCostsPerEmployeeCatalog(costsPerEmployee: CostsPerEmployee): Observable<CostsPerEmployee>{
    return this.http.post<CostsPerEmployee>(this.url, costsPerEmployee);
  }

  updateCostsPerEmployeeCatalog(costsPerEmployee: CostsPerEmployee): Observable<CostsPerEmployee>{
    return this.http.put<CostsPerEmployee>(`${this.url}/${costsPerEmployee.id}`, costsPerEmployee);
  }

}